var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideeye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-hide-1235603",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.562,
    height: 15.227,
    viewBox: "0 0 20.562 15.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3666",
    "data-name": "Path 3666",
    d: "M103.977,195.04a11.536,11.536,0,0,0,7.242,3.114,8.549,8.549,0,0,0,2.416-.361.463.463,0,1,0-.261-.888,7.626,7.626,0,0,1-2.154.324c-4.473,0-8.308-4.392-9.235-5.548a19.85,19.85,0,0,1,2.994-2.975.466.466,0,0,0-.587-.724,19.938,19.938,0,0,0-3.363,3.426.462.462,0,0,0,0,.546,19.815,19.815,0,0,0,2.95,3.086Z",
    transform: "translate(-100.938 -184.067)",
    fill: "#f37320"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3667",
    "data-name": "Path 3667",
    d: "M183.356,102.9a19.815,19.815,0,0,0-2.95-3.086,11.541,11.541,0,0,0-7.242-3.114,9.606,9.606,0,0,0-4.556,1.262l-2.268-2.268a.463.463,0,1,0-.654.654l14.3,14.3a.463.463,0,1,0,.654-.654l-2.094-2.094h0a19.573,19.573,0,0,0,4.808-4.457.462.462,0,0,0,0-.546Zm-7.8,2.013-4.138-4.138a2.961,2.961,0,0,1,4.138,4.138Zm2.312,2.312-1.651-1.648a3.888,3.888,0,0,0-5.458-5.46l-1.47-1.47a8.539,8.539,0,0,1,3.872-1.022c4.473,0,8.308,4.392,9.233,5.548a18.865,18.865,0,0,1-4.522,4.057Z",
    transform: "translate(-162.883 -95.557)",
    fill: "#f37320"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3668",
    "data-name": "Path 3668",
    d: "M260.161,272.688a.462.462,0,0,0-.462-.462,2.968,2.968,0,0,1-2.964-2.964.462.462,0,1,0-.925,0,3.893,3.893,0,0,0,3.888,3.888.462.462,0,0,0,.462-.462Z",
    transform: "translate(-249.418 -261.648)",
    fill: "#f37320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideeye);
export default __webpack_public_path__ + "static/media/hideeye.3d5599b07c93bee615136d5d682d412a.svg";
export { ForwardRef as ReactComponent };